import React from 'react';
import { HelpCircleIcon, MessageCircleIcon } from 'lucide-react';
interface TopBarProps {
  businessName: string;
}
export const TopBar = ({
  businessName
}: TopBarProps) => {
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <div className="h-16 flex items-center justify-between" data-id="element-104">
          <div className="flex items-center" data-id="element-105">
            {/* Logo */}
            <div className="text-indigo-600 font-bold text-xl" data-id="element-106">
              PrivacyShield
            </div>
          </div>
          {/* Business name - centered */}
          <div className="hidden md:block text-gray-600 font-medium" data-id="element-107">
            {businessName}
          </div>
          {/* Right actions */}
          <div className="flex items-center space-x-4" data-id="element-108">
            <button className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-150" data-id="element-109">
              <HelpCircleIcon size={20} data-id="element-110" />
            </button>
            <button className="flex items-center space-x-2 bg-indigo-50 text-indigo-600 px-3 py-2 rounded-lg hover:bg-indigo-100 transition-colors duration-150" data-id="element-111">
              <MessageCircleIcon size={18} data-id="element-112" />
              <span className="hidden sm:inline font-medium" data-id="element-113">
                Chat with DPO
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>;
};